const tabs = $('.about__tab-list');

const fn = {
    init: () => {
        if ($('.about__tab-list').length) {
            // console.log('Milestones loaded');
            var milestoneLink = $('.about__tab-list').find('.nav-link');
            var milestoneTab = $('.tab-content').find('.tab-pane');

            milestoneLink.on('click', function(e) {
                e.preventDefault();
                var target = $(this).attr('data-toggle');
                // animate
                const activeTab = document.getElementById(`${target}`);
                milestoneLink.removeClass('active');
                milestoneTab.removeClass('active');
                $(this).addClass('active');
                $(activeTab).addClass('active');

                return false;
            });
        }
    }
}

export default {
    can: () => tabs.length,
    run: fn.init,
};
